import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

import instagram_square from '../../../assets/img/instagram-square.png';


class ToS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Terms of Service </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-4 line-height-h">
                    <b>Agreement between user and https://www.abilitaxr.com</b>
                    <br></br>
                    Welcome to https://www.abilitaxr.com. https://www.abilitaxr.com is offered to you 
                    conditioned on your acceptance without modification of the terms, conditions, 
                    and notices contained herein (the "Terms"). Your use of https://www.abilitaxr.com 
                    constitutes your agreement to all such Terms. Please read these terms carefully, 
                    and keep a copy of them for your reference.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Your account</b>
                    <br></br>
                    If you use this site, you are responsible for maintaining the confidentiality 
                    of your account and password and for restricting access to your computer, 
                    and you agree to accept responsibility for all activities that occur under 
                    your account or password. You may not assign or otherwise transfer your account 
                    to any other person or entity. You acknowledge that AbilitàXR is not responsible 
                    for third party access to your account that results from theft or misappropriation of 
                    your account. AbilitàXR and its associates reserve the right to refuse or cancel service, 
                    terminate accounts, or remove or edit content in our sole discretion.
                    <br></br>
                    AbilitàXR does not knowingly collect, either online or offline, personal information from 
                    persons under the age of thirteen. If you are under 18, you may use 
                    https://www.abilitaxr.com only with permission of a parent or guardian.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Privacy</b>
                    <br></br>
                    Your use of https://www.abilitaxr.com is subject to AbilitàXR’s Privacy Policy. 
                    Please review our Privacy Policy, which also governs the Site and informs users 
                    of our data collection practices..
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Electronic Communications</b>
                    <br></br>
                    Visiting https://www.abilitaxr.com or sending e-mails to AbilitàXR constitutes 
                    electronic communications. You consent to receive electronic communications 
                    and you agree that all agreements, notices, disclosures and other communications 
                    that we provide to you electronically, via e-mail and on the Site, satisfy any legal 
                    requirement that such communications be in writing.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Use of communication services</b>
                    <br></br>
                    The Site may contain bulletin board services, chat areas, news groups, forums, communities, 
                    personal web pages, calendars, and/or other message or communication facilities designed to 
                    enable you to communicate with the public at large or with a group (collectively, "Communication Services"), 
                    you agree to use the Communication Services only to post, send and receive messages and material that 
                    are proper and related to the particular Communication Service.
                    <br></br>
                    By way of example, and not as a limitation, you agree that when using a Communication Service, 
                    you will not: defame, abuse, harass, stalk, threaten or otherwise violate the legal rights 
                    (such as rights of privacy and publicity) of others; publish, post, upload, distribute or 
                    disseminate any inappropriate, profane, defamatory, infringing, obscene, indecent or unlawful topic, 
                    name, material or information; upload files that contain software or other material protected by 
                    intellectual property laws (or by rights of privacy of publicity) unless you own or control the rights 
                    thereto or have received all necessary consents; upload files that contain viruses, corrupted files, 
                    or any other similar software or programs that may damage the operation of another's computer; 
                    advertise or offer to sell or buy any goods or services for any business purpose, unless such 
                    Communication Service specifically allows such messages; conduct or forward surveys, contests, 
                    pyramid schemes or chain letters; download any file posted by another user of a Communication 
                    Service that you know, or reasonably should know, cannot be legally distributed in such manner; 
                    falsify or delete any author attributions, legal or other proper notices or proprietary designations 
                    or labels of the origin or source of software or other material contained in a file that is uploaded, 
                    restrict or inhibit any other user from using and enjoying the Communication Services; violate any 
                    code of conduct or other guidelines which may be applicable for any particular Communication Service; 
                    harvest or otherwise collect information about others, including e-mail addresses, without their consent; 
                    violate any applicable laws or regulations.
                    <br></br>
                    AbilitàXR has no obligation to monitor the Communication Services. However, AbilitàXR reserves the 
                    right to review materials posted to a Communication Service and to remove any materials in its 
                    sole discretion. AbilitàXR reserves the right to terminate your access to any or all of the 
                    Communication Services at any time without notice for any reason whatsoever.
                    <br></br>
                    AbilitàXR reserves the right at all times to disclose any information as necessary to satisfy 
                    any applicable law, regulation, legal process or governmental request, or to edit, refuse to 
                    post or to remove any information or materials, in whole or in part, in AbilitàXR's sole discretion.
                    <br></br>
                    Always use caution when giving out any personally identifying information about yourself or 
                    your children in any Communication Service. AbilitàXR does not control or endorse the content, 
                    messages or information found in any Communication Service and, therefore, AbilitàXR 
                    specifically disclaims any liability with regard to the Communication Services and 
                    any actions resulting from your participation in any Communication Service. 
                    Managers and hosts are not authorized AbilitàXR spokespersons, and their views do not 
                    necessarily reflect those of AbilitàXR.
                    <br></br>
                    Materials uploaded to a Communication Service may be subject to posted limitations on usage, 
                    reproduction and/or dissemination. You are responsible for adhering to such limitations 
                    if you upload the materials.
                    <br></br>
                    Materials provided to https://www.abilitaxr.com or posted on any AbilitàXR web page
                    <br></br>
                    AbilitàXR does not claim ownership of the materials you provide to https://www.abilitaxr.com 
                    (including feedback and suggestions) or post, upload, input or submit to any AbilitàXR 
                    Site or our associated services (collectively "Submissions"). However, by posting, uploading, 
                    inputting, providing or submitting your Submission you are granting AbilitàXR, our affiliated 
                    companies and necessary sublicensees permission to use your Submission in connection with the 
                    operation of their Internet businesses including, without limitation, the rights to: copy, 
                    distribute, transmit, publicly display, publicly perform, reproduce, edit, translate and 
                    reformat your Submission; and to publish your name in connection with your Submission.
                    <br></br>
                    No compensation will be paid with respect to the use of your Submission, as provided herein. 
                    AbilitàXR is under no obligation to post or use any Submission you may provide and may remove 
                    any Submission at any time in AbilitàXR's sole discretion.
                    <br></br>
                    By posting, uploading, inputting, providing or submitting your Submission you warrant 
                    and represent that you own or otherwise control all of the rights to your Submission as 
                    described in this section including, without limitation, all the rights necessary for you to provide, 
                    post, upload, input or submit the Submissions.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>User Conduct and Rules</b>
                    <br></br>
                    You agree and undertake to use the Website and the Service only to post and upload messages 
                    and material that are proper. By way of example, and not as a limitation, you agree and 
                    undertake that when using a Service, you will not:
                    <br></br>
                    (a)  defame, abuse, harass, stalk, threaten or otherwise violate the legal rights of others;
                    <br></br>
                    (b)  publish, post, upload, distribute or disseminate any inappropriate, profane, defamatory, 
                    infringing, obscene, indecent or unlawful topic, name, material or information;
                    <br></br>
                    (c)  upload files that contain software or other material protected by intellectual property 
                    laws unless you own or control the rights thereto or have received all necessary consents; 
                    you own or control the rights thereto or have received all necessary consents;
                    <br></br>
                    (d)  upload or distribute files that contain viruses, corrupted files, or any other similar 
                    software or programs that may damage the operation of the Website or another's computer;
                    <br></br>
                    (e)  conduct or forward surveys, contests, pyramid schemes or chain letters;
                    <br></br>
                    (f)  download any file posted by another user of a Service that you know, or reasonably 
                    should know, cannot be legally distributed in such manner;
                    <br></br>
                    (g)  falsify or delete any author attributions, legal or other proper notices or proprietary 
                    designations or labels of the origin or source of software or other material contained in a 
                    file that is uploaded;
                    <br></br>
                    (h)  violate any code of conduct or other guidelines, which may be applicable for or to any 
                    particular Service;
                    <br></br>
                    (i)  violate any applicable laws or regulations for the time being in force in or outside India; and
                    <br></br>
                    (j)  violate, abuse, unethically manipulate or exploit, any of the terms and conditions 
                    of this Agreement or any other terms and conditions for the use of the Website contained elsewhere.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>User Warranty and Representation</b>
                    <br></br>
                    The user guarantees, warrants, and certifies that you are the owner of the content 
                    which you submit or otherwise authorised to use the content and that the content 
                    does not infringe upon the property rights, intellectual property rights or other 
                    rights of others. You further warrant that to your knowledge, no action, suit, proceeding, 
                    or investigation has been instituted or threatened relating to any content, including trademark, 
                    trade name service mark, and copyright formerly or currently used by you in connection 
                    with the Services rendered by AbilitàXR.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>No unlawful or prohibited use/Intellectual Property</b>
                    <br></br>
                    You are granted a non-exclusive, non-transferable, revocable license to access and 
                    use https://www.abilitaxr.com strictly in accordance with these terms of use. 
                    As a condition of your use of the Site, you warrant to AbilitàXR that you will not use 
                    the Site for any purpose that is unlawful or prohibited by these Terms. You may not 
                    use the Site in any manner which could damage, disable, overburden, or impair the Site 
                    or interfere with any other party's use and enjoyment of the Site. You may not obtain or 
                    attempt to obtain any materials or information through any means not intentionally made 
                    available or provided for through the Site.
                    <br></br>
                    All content included as part of the Service, such as text, graphics, logos, images, 
                    as well as the compilation thereof, and any software used on the Site, is the property 
                    of AbilitàXR or its suppliers and protected by copyright and other laws that protect 
                    intellectual property and proprietary rights. You agree to observe and abide by all 
                    copyright and other proprietary notices, legends or other restrictions contained in 
                    any such content and will not make any changes thereto.
                    <br></br>
                    You will not modify, publish, transmit, reverse engineer, participate in the transfer 
                    or sale, create derivative works, or in any way exploit any of the content, in whole or 
                    in part, found on the Site. AbilitàXR content is not for resale. Your use of the Site does 
                    not entitle you to make any unauthorized use of any protected content, and in particular 
                    you will not delete or alter any proprietary rights or attribution notices in any content. 
                    You will use protected content solely for your personal use, and will make no other use of 
                    the content without the express written permission of AbilitàXR and the copyright owner. 
                    You agree that you do not acquire any ownership rights in any protected content. We do not 
                    grant you any licenses, express or implied, to the intellectual property of AbilitàXR or our 
                    licensors except as expressly authorized by these Terms.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Links to third party sites/Third party services</b>
                    <br></br>
                    https://www.abilitaxr.com may contain links to other websites ("Linked Sites"). 
                    The Linked Sites are not under the control of AbilitàXR and AbilitàXR is not responsible for 
                    the contents of any Linked Site, including without limitation any link contained in a Linked Site, 
                    or any changes or updates to a Linked Site. AbilitàXR is providing these links to you only as a 
                    convenience, and the inclusion of any link does not imply endorsement by AbilitàXR  of the 
                    site or any association with its operators.
                    <br></br>
                    Certain services made available via https://www.abilitaxr.com are delivered by third party 
                    sites and organizations. By using any product, service or functionality originating from the 
                    https://www.abilitaxr.com domain, you hereby acknowledge and consent that AbilitàXR may share 
                    such information and data with any third party with whom AbilitàXR has a contractual 
                    relationship to provide the requested product, service or functionality on behalf of 
                    https://www.abilitaxr.com users and customers.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Third Party Accounts</b>
                    <br></br>
                    You will be able to connect your AbilitàXR account to third party accounts. 
                    By connecting your AbilitàXR account to your third party account, 
                    you acknowledge and agree that you are consenting to the continuous release 
                    of information about you to others (in accordance with your privacy settings 
                    on those third party sites). If you do not want information about you to be shared 
                    in this manner, do not use this feature.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Indemnification</b>
                    <br></br>
                    You agree to indemnify, defend and hold harmless AbilitàXR 
                    from and against any and all losses, liabilities, claims, damages, 
                    costs and expenses (including legal fees and disbursements in connection 
                    therewith and interest chargeable thereon) asserted against or incurred 
                    by AbilitàXR that arise out of, result from, or may be payable by virtue of, 
                    any breach or non-performance of any representation, warranty, covenant or 
                    agreement made or obligation to be performed by you pursuant to these Terms.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Disclaimer Of Warranties/Limitation Of Liability</b>
                    <br></br>
                    AbilitàXR has endeavoured to ensure that all the information on the Website is correct, 
                    but AbilitàXR neither warrants nor makes any representations regarding the quality, 
                    accuracy or completeness of any data, information, product or Service. In no event 
                    shall AbilitàXR be liable for any direct, indirect, punitive, incidental, special, 
                    consequential damages or any other damages resulting from: (a) the use or the inability 
                    to use the Services or Products; (b) unauthorized access to or alteration of the user's 
                    transmissions or data; (c) any other matter relating to the services; including, without limitation, 
                    damages for loss of use, data or profits, arising out of or in any way connected with the use or 
                    performance of the Website or Service. Neither shall AbilitàXR be responsible for the delay or 
                    inability to use the Website or related services, the provision of or failure to provide Services, 
                    or for any information, software, products, services and related graphics obtained through the Website, 
                    or otherwise arising out of the use of the website, whether based on contract, tort, negligence, 
                    strict liability or otherwise. Further, AbilitàXR shall not be held responsible for non-availability 
                    of the Website during periodic maintenance operations or any unplanned suspension of access to the 
                    website that may occur due to technical reasons or for any reason beyond AbilitàXR's control. The user 
                    understands and agrees that any material and/or data downloaded or otherwise obtained through the Website 
                    is done entirely at their own discretion and risk and they will be solely responsible for any damage to 
                    their computer systems or loss of data that results from the download of such material and/or data
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Termination/access restriction</b>
                    <br></br>
                    AbilitàXR reserves the right, in its sole discretion, to terminate your access to the 
                    Site and the related services or any portion thereof at any time, without notice. 
                    To the maximum extent permitted by law, this agreement is governed by the laws of 
                    the State of California and you hereby consent to the exclusive jurisdiction and venue 
                    of courts in California in all disputes arising out of or relating to the use of the Site. 
                    Use of the Site is unauthorized in any jurisdiction that does not give effect to all provisions 
                    of these Terms, including, without limitation, this section.
                    <br></br>
                    You agree that no joint venture, partnership, employment, or agency relationship exists 
                    between you and AbilitàXR as a result of this agreement or use of the Site. AbilitàXR's performance 
                    of this agreement is subject to existing laws and legal process, and nothing contained in this 
                    agreement is in derogation of AbilitàXR's right to comply with governmental, court and law enforcement 
                    requests or requirements relating to your use of the Site or information provided to or gathered by 
                    AbilitàXR with respect to such use. If any part of this agreement is determined to be invalid or unenforceable 
                    pursuant to applicable law including, but not limited to, the warranty disclaimers and liability limitations 
                    set forth above, then the invalid or unenforceable provision will be deemed superseded by a valid, 
                    enforceable provision that most closely matches the intent of the original provision and the remainder 
                    of the agreement shall continue in effect.
                    <br></br>
                    Unless otherwise specified herein, this agreement constitutes the entire agreement between the user and 
                    AbilitàXR with respect to the Site and it supersedes all prior or contemporaneous communications and proposals, 
                    whether electronic, oral or written, between the user and AbilitàXR with respect to the Site. A printed version 
                    of this agreement and of any notice given in electronic form shall be admissible in judicial or administrative 
                    proceedings based upon or relating to this agreement to the same extent and subject to the same conditions as 
                    other business documents and records originally generated and maintained in printed form. It is the express wish 
                    to the parties that this agreement and all related documents be written in English.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Governing Law</b>
                    <br></br>
                    These terms shall be governed by and constructed in accordance with the laws of India without 
                    reference to conflict of laws principles and disputes arising in relation hereto shall be subject 
                    to the exclusive jurisdiction of the courts at Bengaluru.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Changes to Terms</b>
                    <br></br>
                    AbilitàXR reserves the right, in its sole discretion, to change the Terms under which 
                    https://www.abilitaxr.com is offered. The most current version of the Terms will 
                    supersede all previous versions. AbilitàXR encourages you to periodically review the 
                    Terms to stay informed of our updates.
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                    <b>Contact Us</b>
                    <br></br>
                    AbilitàXR welcomes your questions or comments regarding the Terms:
                    <br></br>
                    Effective as of July 30, 2021
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      <br></br>
                      <br></br>
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
  {/* -------------- Footer Start -------- */}
                <Row className="mt-5">
                </Row>
                <Row className="pt-5 pb-5 home-background-gray">
                  <Col xs="0" sm="0" lg="1">
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "ml-2 text-left">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>PRODUCT</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                         <a href = "/feature"><div className = "font-size-10" >Features</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/appguide"><div className = "font-size-10" >App Guide</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <div className = "font-size-10" >Platform Guide</div>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "/customdev"><div className = "font-size-10" >Custom Development</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <div className = "font-size-10" >Pricing</div>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "https://goo.gl/1s6PZH" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" >Get VR Headset</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div >USE CASES</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/realestate"><div className = "font-size-10" >Real Estate</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/architecture"><div className = "font-size-10" >Architecture</div></a>
                      </Col>
                      <Col className = "mb-2  text-secondary" md = '12'> 
                        <a href = "/medical"><div className = "font-size-10" >Medical</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/retail"><div className = "font-size-10" >Retail</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/sports"><div className = "font-size-10" >Sports</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/media"><div className = "font-size-10" >Media</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/travel"><div className = "font-size-10" >Travel</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/education"><div className = "font-size-10" >Education</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/training"><div className = "font-size-10" >Training</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/ecommerce"><div className = "font-size-10" >Ecommerce</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/entertainment"><div className = "font-size-10" >Entertainment</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>Support</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "http://www.icomputinglabs.in/blog/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" >Blog</div> </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/faq"><div className = "font-size-10" >FAQ</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/contact"><div className = "font-size-10" >Contact</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>COMPANY</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/about"><div className = "font-size-10" >About</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/privacy"><div className = "font-size-10" >Privacy Policy</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/tos"><div className = "font-size-10" >Terms of Service</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>GET CONNECTED</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.facebook.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-facebook-square fa-lg mr-2" />facebook</div>
                        </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.instagram.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><img  alt="" src={instagram_square} className = "text-primary width-16 mr-2" />instagram</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "https://twitter.com/iComputingLabs" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-twitter-square fa-lg mr-2" />twitter</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'>
                        <a href = "https://www.linkedin.com/company/13404850/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-linkedin-square fa-lg mr-2" />linkedin</div>
                        </a>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              {/* -------------- Footer End -------- */}
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default ToS;



// WEBPACK FOOTER //
// ./src/views/Pages/ToS/ToS.js